import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import EditAgreementModal from '~/components/EditAgreementModal/EditAgreementModal';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { handleRequest } from '~/infra/utils';
const loader = 'getRelationship';
export function useOpenEditAgreementModal() {
    const { api, logBI } = useStoreActions();
    const overlayContext = useOverlayContext();
    async function getRelationship(options) {
        if (options.relationship) {
            return options.relationship;
        } else {
            overlayContext.startLoader(loader);
            const relationship = await handleRequest(api.relationship.get(options.relationshipId, {
                // We need paymentMethod info for the edit-agreement modal.
                resolvePaymentMethod: true
            }));
            overlayContext.stopLoader(loader);
            return relationship.data;
        }
    }
    return async (options)=>{
        const relationship = await getRelationship(options);
        if (relationship) {
            logBI(11000);
            return overlayContext.showModal({
                biName: 'edit_agreement_modal',
                content: (props)=>/*#__PURE__*/ _jsx(EditAgreementModal, _object_spread_props(_object_spread({}, props), {
                        relationship: relationship,
                        onUpdate: options.onUpdate
                    }))
            });
        }
    };
}
